import styled from 'styled-components';

export const Container = styled.div`
  padding: 0px;
`;

export const Header = styled.div`
  h3 {
    color: #393939;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

export const Line = styled.div`
  height: 1px;
  background: #364445;
`;

export const FormContainer = styled.div`
  padding: 10px 24px;
`;

export const FormTitle = styled.h4`
  font-size: 14px;
  font-weight: 600;
  line-height: 19px;
  margin: 10px 0 18px;
  color: #393939;
`;

export const Form = styled.form`
  padding-bottom: 20px;
  label {
    display: flex;
    flex-direction: column;
    gap: 10px;

    font-size: 14px;
    font-weight: 800;
    line-height: 19px;
    letter-spacing: 0em;
  }

  input {
    width: 100%;
  }

  .row input {
    margin-top: 0px;
  }

  .ui.grid > .row {
    padding-bottom: 0px;
  }
`;

export const DisclaimerContainer = styled.div`
  padding: 24px 48px;
`;

export const Disclaimer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  justify-content: center;
  align-items: center;
  min-height: 60px;
  padding: 18px 24px;
  border-radius: 11px;
  border: 2px solid ${props => props.theme.main.color};

  p {
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0em;
  }

  time {
    color: ${props => props.theme.main.color};
    font-weight: bold;
  }

  i {
    background: ${props => props.theme.main.color};
    color: white;
    border-radius: 2px;
    box-shadow: 0px 0px 1px ${props => props.theme.main.color}70;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  align-items: center;
  width: 100%;
  margin-top: 20px;
`;

export const QuotationContainer = styled.div`
  margin-top: 20px;
  border: 1px solid rgba(114, 114, 114, 0.29);
  border-radius: 4px;
`;

export const QuotationHeader = styled.div`
  display: flex;
  padding: 10px 16px;
  align-items: center;
  align-self: stretch;
  background-color: ${props => props.theme.main.color};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  h3 {
    color: #ffffff;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

export const QuotationResultContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
`;

export const QuotationListItem = styled.div<{ $isOdd: boolean }>`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background-color: ${props => (props.$isOdd ? '#F6F6F6' : '#ffffff')};

  .item-name {
    display: flex;
    flex-direction: row;
    gap: 4px;
    color: #393939;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    flex-wrap: wrap;
    padding: 4px 0;

    .required-message {
      font-weight: 400;
      color: ${props => props.theme.main.color};
      font-size: 12px;
    }
  }

  .not-included {
    color: #a3a3a3;
  }

  .value {
    color: ${props => props.theme.main.color};
    font-size: 14px;
    white-space: nowrap;
    display: flex;
    padding: 4px 0;
    align-items: baseline;
  }
`;

const minHeightValue = '200px';

export const QuotationList = styled.div`
  width: 60%;
  border-right: 1px solid rgba(114, 114, 114, 0.29);
  min-height: minHeightValue;
`;

export const QuotationValue = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 24px;
  width: 40%;
  min-height: minHeightValue;
  h3 {
    color: ${props => props.theme.main.color};
    font-size: 12px;
    font-weight: 600;
  }

  label {
    display: flex;
    align-items: baseline;
    flex-direction: row;
    gap: 6px;
    color: ${props => props.theme.main.color};
    font-size: 28px;
    font-weight: 700;

    small {
      color: ${props => props.theme.main.color};
      font-size: 20px;
      font-weight: 600;
    }
  }

  small {
    color: #999;
    font-size: 12px;
    font-weight: 400;
    margin-top: 4px;
  }
`;

type CoveragesRowProps = {
  offwhite?: boolean;
};

export const CoveragesRow = styled.div<CoveragesRowProps>`
  width: 100%;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-weight: 600;
  background-color: ${props => (props.offwhite ? '#eee' : '#fff')};
  padding: 10px 5px;
  margin: 0;
  .low-opacity {
    opacity: 0.5;
  }
  .required {
    color: ${props => props.theme.main.color};
  }

  .slice-insurance-name {
    display: block;
    width: 180px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .insurance-name {
    display: flex;
    flex-direction: row;
  }

  .insurance-value {
    color: ${props => props.theme.main.color};
  }
  .pencil-icon {
    margin-left: 5px;
    font-size: 14px;
    cursor: pointer;
    &:hover {
      opacity: 1;
    }
  }

  .editable-coverages {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 8px;

    .editable-coverages-input {
      width: 150px;
      font-size: 14px;
    }

    .icon {
      cursor: pointer;
    }
  }

  input[type='checkbox'] {
    position: relative;
    cursor: pointer;
    width: 20px;
    height: 17px;
    margin-right: 10px;
  }
  input[type='checkbox']:before {
    content: '';
    display: block;
    width: 20px;
    height: 20px;
  }
  input[type='checkbox']:checked:before {
    content: '';
    display: block;
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  input[type='checkbox']:checked:after {
    content: '';
    display: block;
    width: 5px;
    height: 10px;
    border: 1px solid ${props => props.theme.main.color};
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    position: absolute;
    top: 5px;
    left: 8px;
  }
`;
